module.exports = __webpack_public_path__ + "assets/2ca58133b656bf1115b97f33bb874472.json";